import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { Skeleton } from "@material-ui/lab"
import { PDFViewer, ExcelViewer, UnsupportedViewer, EmailViewer, PictureViewer } from "./fileTypes"
import { ViewerHeader } from "../../../components/viewer"
import AudioViewer from "./fileTypes/AudioViewer"
import VideoViewer from "./fileTypes/VideoViewer"
import PictureViewerWrapper from "./fileTypes/PictureViewerWrapper"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		padding: "16px 23px",
		marginBottom: "20px",
		height: "70vh",
	},
}))

const FileViewer = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [source, setSource] = useState("")
	const { documentDetails, documentLoading } = useSelector((state) => state.documentModal)
	const getFileTypeViewer = (source) => {
		switch (source) {
			case "csv":
			case "xlsx":
			case "docx":
			case "doc":
			case "pdf": {
				return <PDFViewer {...props} />
			}
			case "email": {
				return <EmailViewer {...props} />
			}
			case "jpg":
			case "jpeg":
			case "gif":
			case "png":
			case "img":
			case "bmp":
			case "mng": {
				return <PictureViewerWrapper {...props} />
			}
			case "video": {
				return <VideoViewer {...props} />
			}
			case "audio": {
				return <AudioViewer {...props} />
			}
			default: {
				return <UnsupportedViewer {...props} />
			}
		}
	}

	return (
		<>
			<ViewerHeader {...props} />
			<Box className={classes.root}>
				{props?.loading ? (
					<Skeleton variant="rect" width="100%" style={{ margin: "5px", padding: "10px", height: "60vh" }}></Skeleton>
				) : (
					<Box>{getFileTypeViewer(documentDetails?.metadata?.source)}</Box>
				)}
			</Box>
		</>
	)
}

export default FileViewer
